import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Store } from "@ngxs/store";
import { map } from "rxjs/operators";
import { UserPerformanceModel } from "src/app/shared/interfaces/user-performance";
import {
  GET_PAGE_ACCESS,
  GET_USER_PERFORMANCE,
} from "src/app/store/user-performance/user-performance.action";

import { UserPerformanceService } from "./user-performance.service";

@State<UserPerformanceModel>({
  name: "UserPerformanceState",
  defaults: {
    gwpData: null,
    gwpChartData: null,
    pageAccess: null,
  },
})
@Injectable()
export class UserPerformanceState {
  constructor(
    private readonly UserPerformanceService: UserPerformanceService,
    private readonly store: Store,
  ) {}

  @Selector()
  public static gwpChartData(state: UserPerformanceModel) {
    return state?.gwpChartData ?? null;
  }

  @Selector()
  public static grossClaimRatio(state: UserPerformanceModel) {
    return state?.gwpData?.grossClaimRatio ?? null;
  }

  @Action(GET_USER_PERFORMANCE)
  public getUserPerformance(
    { patchState }: StateContext<UserPerformanceModel>,
    { payload }: GET_USER_PERFORMANCE,
  ) {
    return this.UserPerformanceService.getUserPerformance(payload).pipe(
      map((res) => {
        patchState({
          gwpData: res ? res : null,
          gwpChartData: res ? res.gwp : null,
        });
      }),
    );
  }

  @Action(GET_PAGE_ACCESS)
  public getPageAccess(
    { patchState }: StateContext<UserPerformanceModel>,
    { payload }: GET_PAGE_ACCESS,
  ) {
    return this.UserPerformanceService.getPageAccess(payload).pipe(
      map((res) => {
        patchState({
          pageAccess: res ? res : null,
        });
      }),
    );
  }
}
